export default "__VITE_ASSET__3e17bda0__"